import axios from "./axios";

export const visitEntity = async (entityId: string): Promise<any> => {
  try {
    const response = await axios.put<any>(
      `/football-entities/${entityId}/visited`
    );
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed visit entity profile");
  }
};

export const visitUser = async (userId: string): Promise<any> => {
  try {
    const response = await axios.post<any>(`/users/${userId}/visited`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed visit user profile");
  }
};
